const seoTextsToggle = {
	'short': `
			<p>
				Підключення до акційного тарифу «IPnet 20 років» вартістю 20 грн/міс. можливе тільки для нових абонентів.
				Акційні умови діють протягом 20 місяців з моменту підключення, після закінчення акційного періоду абонент
				автоматично переводиться на тарифний план «Чистий Гігабіт».
			</p>`,
	'full': `
		<p>
			Підключення до акційного тарифу «IPnet 20 років» вартістю 20 грн/міс. можливе тільки для нових абонентів.
			Акційні умови діють протягом 20 місяців з моменту підключення, після закінчення акційного періоду абонент
			автоматично переводиться на тарифний план «Чистий Гігабіт».
		</p>
		<p>
			Акційна вартість підключення до мережі та налаштування і доставки роутеру складає 199 грн. Підключитися до
			акційного тарифу «IPnet 20 років» можливо тільки за умови придбання роутеру TP-Link Archer C5 Pro за повною
			вартістю 1100,00 грн. (одним платежем), або у розстрочку на 5 місяців (5 платежів по 220,00 грн щомісячно).
			Перший мінімальний платіж при підключенні має складати 439,00 грн (20 грн – абонплата за перший місяць
			користування, 199,00 грн – роботи з підключення та налаштування, 220,00 грн – перша частина оплати за роутер).
			Всі ціни наведені в гривні з урахуванням ПДВ. При підключенні потрібно підписати Додаткову Угоду строком на 5
			місяців користування. Акція не поширюється на абонентів, які мають діючий або розірваний в період дії акції
			договір за місцем надання послуги. Ви можете підключитися до високошвидкісного акційного тарифу “IPnet 20 років”
			з 28 серпня 2021 р. до 31 жовтня 2021 р.
		</p>`
}
export default seoTextsToggle;